// import img01 from "../assets/images/olympo36/img01.jpg"
import img01 from "../assets/images/OLYMPO35/ACABADO DE TECHO.webp"
// import img02 from "../assets/images/olympo36/img02.jpg"
import img02 from "../assets/images/OLYMPO35/ESTANDAR/salon-pasajeros---acabado-lateral.jpg"
// import img03 from "../assets/images/olympo36/img03.jpg"
import img03 from "../assets/images/OLYMPO35/ACABADO DE PISO.webp"
// import img04 from "../assets/images/olympo36/img04.jpg"
import img04 from "../assets/images/OLYMPO35/ILUMINACION.webp"
// import img05 from "../assets/images/olympo36/img05.jpg"
import img05 from "../assets/images/OLYMPO35/PAQUETERAS.webp"
import img06 from "../assets/images/OLYMPO35/CABINA/CUPULA.webp"
// import img07 from "../assets/images/olympo36/img07.jpg"
import img07 from "../assets/images/OLYMPO35/CABINA/MAMPARADIVISORIA.webp"
// import img08 from "../assets/images/olympo36/img08.jpg"
import img08 from "../assets/images/OLYMPO35/CABINA/TABLERODECONTROL.webp"
// import img09 from "../assets/images/olympo36/img09.jpg"
import img09 from "../assets/images/OLYMPO35/ESTANDAR/cabina-conductor---grada-de-ingreso.jpg"
import img10 from "../assets/images/OLYMPO35/EXTERIOR/FRONTAL.webp"
// import img11 from "../assets/images/OLYMPO35/ESTANDAR/exterior-1.jpg"
import img11 from "../assets/images/OLYMPO35/EXTERIOR/POSTERIOR.webp"
// import img12 from "../assets/images/olympo36/img12.jpg"
// import img13 from "../assets/images/olympo36/img13.jpg"
import img13 from "../assets/images/OLYMPO35/CALEFACCION.webp"
// import img14 from "../assets/images/olympo36/img14.jpg"
import img14 from "../assets/images/OLYMPO35/ESTANDAR/salon-pasajeros---asientos.jpg"
// import img15 from "../assets/images/olympo36/img15.jpg"
import img15 from "../assets/images/OLYMPO35/CARACTERISTICAS/AIREACONDICIONADO.webp"
// import img16 from "../assets/images/olympo36/img16.jpg"
import img16 from "../assets/images/OLYMPO35/OPCIONALES/bano.jpg"
// import img17 from "../assets/images/olympo36/img17.jpg"
import img17 from "../assets/images/OLYMPO35/CONDUCCION/ESPEJOSRETROVISORES.webp"
// import img18 from "../assets/images/olympo36/img18.jpg"
import img18 from "../assets/images/OLYMPO35/CONDUCCION/TABLERODE CONTROL.webp"
import img19 from "../assets/images/OLYMPO35/EXTERIOR/LATERAL.webp"
import img22 from "../assets/images/OLYMPO29/ESTANDAR/conduccion---accionamiento-de-puerta-de-servicio.jpg"
export const OlympoBlock1 = [
  {
    title: `ACABADO TECHO`,
    text: `<li>Decorado con material PVC DECORATIVO que es impermeable, de fácil limpieza, antinflamable y aislante térmico.</li>`,
    img: img01,
  },
  {
    title: `ACABADO LATERALES`,
    text: `<li> Decorado con material PVC DECORATIVO.</li> <li>Perfilado de marcos de ventanas con PVC DECORATIVO de brillo natural.</li>`,
    img: img02,
  },
  {
    title: `ACABADO DE PISO`,
    text: `<li>Cubierto en PVC FLEXIBLE DE ALTO TRÁNSITO de alta resistencia al desgaste.</li> 
    <li>Opciones de colores para el decorado del piso. Es antinflamable y retardante.</li>`,
    img: img03,
  },
  {
    title: `ILUMINACIÓN`,
    text: `<li> Iluminación con tecnología LED a ambos lados del salón en la parte superior (techo).</li>`,
    img: img04,
  },
  {
    title: `PAQUETERAS`,
    text: `<li>LIGERAS y elaboradas en poliuretano rigido de alta densidad.</li>
    <li>Fijadas en el techo estratégicamente para EVITAR VIBRACIONES. Luces de lectura individuales.</li>`,
    img: img05,
  },
  {
    title: `ASIENTOS`,
    text: `<li>Inyectados en espuma de poliuretano flexible, opciones de tapizado en tela navallada o cuero sintético importado. </li>
    <li>Personalización de asientos de acuerdo a necesidades del cliente.</li>`,
    img: img14,
  },
  {
    title: `CALEFACCIÓN`,
    text: `<li>Concentradores de calor y convección forzada.</li>
    <li>Consta de aletas de aluminio (serpentín) distribuidos en todo el salón de pasajeros; sopladores eléctricos silenciosos para un flujo de calor homogeneo.</li>`,
    img: img13,
  },
]
export const OlympoBlock2 = [
  {
    title: `TABLERO DE CONTROL`,
    text: `<li>Diseñado para FACILITAR LA OPERACIÓN de los diferentes mandos de control del bus; diseño AERODINÁMICO y protección externa con poliuretano rígido.`,
    img: img08,
  },
  {
    title: `GRADA DE INGRESO`,
    text: `<li>Con ILUMINACIÓN PROPIA y fabricado en fibra de vidrio.</li>
    <li> Base estructural reforzado. </li>`,
    img: img09,
  },
  {
    title: `CÚPULA`,
    text: `<li>Gravado natural con lineas estilizadas decorativas y definición de contornos para la colocación de luces de cabina, parlantes, entre otros.</li>
    <li>Iluminación con sistema LED.</li>`,
    img: img06,
  },
  {
    title: `MAMPARA DIVISORIA`,
    text: `<li>Diseño decorativo y en armonia con los espacios que divide .</li>
    <li> Su ubicación obedece a la optimización entre el espacio del salón de pasajeros y la cabina de conducción.</li>`,
    img: img07,
  },
]
export const OlympoBlock3 = [
  {
    title: `ISO FRONTAL`,
    text: ` <li> AERODINÁMICO Y ROBUSTO</li>`,
    img: img10,
  },
  {
    title: `ISO POSTERIOR`,
    text: `<li> ROBUSTO</li>`,
    img: img11,
  },
  {
    title: "LATERAL",
    text: "<li>AERODINÁMICO</li>",
    img: img19,
  },
  // {
  //   title: `BODEGAS`,
  //   text: ` Livianas, forradas en aluminio. Puertas de bodegas cuentan con mecanismo de seguridad de doble traba que garantizan un sello hermético.  `,
  //   img: img12,
  // },
]
export const OlympoBlock4 = [
  {
    title: `AIRE ACONDICIONADO`,
    text: `<li>Sistema que intercambia aire fresco del medio ambiente, purificado y climatizado a una determinada temperatura. </li>
    <li>Garantiza comodidad y bienestar a los pasajeros.</li>`,
    img: img15,
  },
  {
    title: `BAÑO`,
    text: `<li>Mixto, urinario con taza. Cuenta con sistema automático de extracción de olores.</li>
    <li> SANITIZACIÓN en base a la utilización de Ozono para la eliminación de agentes infectantes como virus y bacterias.</li>`,
    img: img16,
  },
]
export const OlympoBlock5 = [
  {
    title: "ESPEJOS RETROVISORES",
    text:
      `<li>Eléctricos con mando selector que regulan el angulo de visión del conductor.</li>
      <li> Espejos calefactables para mejorar la visibilidad de conducción en zonas humedas.</li>`,
    img: img17,
  },
  {
    title: "ACCIONAMIENTO PUERTA SERVICIO",
    text:
      "<li>Control inalambrico para mayor seguridad de bloqueo/desbloqueo desde el exterior del bus.</li>",
    img: img22,
  },
  {
    title: "PANEL DE CONTROL",
    text: `<li>Panel digital con tecnología de circuitos impresos con protección “Anti – solder” que garantizan la funcionalidad correcta del bus en los diferentes climas del Perú.</li>`,
    img: img18,
  },
]
export const OlympoBlock6 = []
